module.exports = __webpack_public_path__ + "static/img/jiaoyu-bottom.2c13a41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jiaoyu-bottom.jpg
// module id = rIg3
// module chunks = 0